











import { Vue, Component, Prop } from "vue-property-decorator";
import { SspDataModule } from "@/modules/SspDataModule";
import { FrameStore } from "@/modules/base";
import { env } from '@/env';

@Component
export default class extends Vue {
  @Prop({ required: true })
  module!: SspDataModule

  @Prop({ required: true })
  frameStore!: FrameStore<typeof SspDataModule>

  keybind(rerun: string) {
    const reruns: string[] = []
    for (const r of env.releases) {
      reruns.push(...r.reruns)
    }
    const i = reruns.indexOf(rerun)
    return `shift+${i + 1}`
  }
}
